import React from 'react';
import { Code2Icon, WebhookIcon, PuzzleIcon } from 'lucide-react';
const IntegrationCard = ({
  icon,
  title,
  description
}) => {
  return <div className="bg-white p-6 rounded-xl border border-gray-200 hover:border-orange-200 hover:shadow-lg transition-all duration-300 group" data-id="element-227">
      <div className="mb-4 p-3 bg-gray-50 rounded-lg w-fit group-hover:bg-orange-50 transition-colors" data-id="element-228">
        {icon}
      </div>
      <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-229">{title}</h3>
      <p className="text-gray-600 text-sm leading-relaxed" data-id="element-230">{description}</p>
    </div>;
};
const Integrations = () => {
  const integrations = [{
    icon: <Code2Icon className="text-gray-700 group-hover:text-orange-500" data-id="element-231" />,
    title: 'Web & App Embed',
    description: 'Embed like a normal form. Upgrade UX without changing your data model.'
  }, {
    icon: <WebhookIcon className="text-gray-700 group-hover:text-orange-500" data-id="element-232" />,
    title: 'APIs & Webhooks',
    description: 'Receive structured submissions in real time. Trigger workflows instantly.'
  }, {
    icon: <PuzzleIcon className="text-gray-700 group-hover:text-orange-500" data-id="element-233" />,
    title: 'Custom Integrations',
    description: "Start drop-in. Go deeper when you're ready — build exactly what you need."
  }];
  return <section className="w-full bg-white py-[5.75rem]" id="integrations" data-id="element-234">
      <div className="container mx-auto px-4" data-id="element-235">
        <div className="text-center mb-16" data-id="element-236">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-237">
            Embed Anywhere. Route Anywhere.
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-238">
            Drop FluidForm into your site or app, then send validated
            submissions wherever they belong.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto mb-12" data-id="element-239">
          {integrations.map((item, index) => <IntegrationCard key={index} {...item} data-id="element-240" />)}
        </div>

        <div className="text-center" data-id="element-241">
          <span className="inline-block px-4 py-2 bg-gray-100 rounded-full text-sm font-medium text-gray-600" data-id="element-242">
            Custom API endpoints available for additional integrations
          </span>
        </div>
      </div>
    </section>;
};
export default Integrations;